import { render, staticRenderFns } from "./xgplayer.vue?vue&type=template&id=063fd48a&scoped=true"
import script from "./xgplayer.vue?vue&type=script&lang=js"
export * from "./xgplayer.vue?vue&type=script&lang=js"
import style0 from "./xgplayer.vue?vue&type=style&index=0&id=063fd48a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fd48a",
  null
  
)

export default component.exports